import {
  ICropPercentage,
  ITotalCropData,
} from '@/features/insights/cropHistory/summary';
import { ICDLStatsResponse } from '@/models/cdl';
import { round } from '@/utils/common';

export function calculateCropPercentages(stats: ICDLStatsResponse[]) {
  const totalCropData = {
    cropAcreage: {},
    cropColors: {},
    totalAcres: 0,
  } as ITotalCropData;
  stats.forEach((stat) => {
    if (stat.labels && stat.acres) {
      totalCropData.totalAcres += stat.acres;
      stat.labels.forEach((label, i) => {
        if (!totalCropData.cropAcreage[label]) {
          totalCropData.cropColors[label] =
            stat.legend.find((item) => item.name === label)?.color || '#000000';
          totalCropData.cropAcreage[label] = stat.acres * stat.data[i];
        } else {
          totalCropData.cropAcreage[label] += stat.acres * stat.data[i];
        }
      });
    }
  });

  const cropPercentages: ICropPercentage = {};

  Object.entries(totalCropData.cropAcreage).forEach(([crop, acres]) => {
    cropPercentages[crop] = round((acres / totalCropData.totalAcres) * 100, 1);
  });

  return {
    cropAcres: totalCropData.cropAcreage,
    cropColors: totalCropData.cropColors,
    cropPercentages,
  };
}
